@if (datasetStates.length > 0) {
  <div
    class="flex flex-wrap gap-1 max-h-80 overflow-y-visible mb-2"
    >
    @for (dataset of datasetStates; track trackByLabel($index, dataset)) {
      <div
        class="flex items-center gap-2 px-2 py-1 rounded border-2 border-white shadow-sm cursor-pointer transition-all"
        [class.opacity-60]="!dataset.visible"
        [style.background-color]="dataset.color"
        (click)="toggleDatasetVisibility(dataset)"
        (keydown.enter)="toggleDatasetVisibility(dataset)"
        (keydown.space)="toggleDatasetVisibility(dataset)"
        tabindex="0"
        role="button"
        [attr.aria-label]="'Toggle visibility of ' + dataset.label"
        >
        <span
          class="text-xs font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-32 flex items-center"
          [class.text-white]="getTextColorForContrast(dataset.color) === 'white'"
          [class.text-gray-900]="getTextColorForContrast(dataset.color) === 'dark'"
          [title]="dataset.label"
          >
          {{ dataset.label }}
        </span>
        <button
          class="w-5 h-5 p-0 border-0 bg-transparent rounded cursor-pointer flex items-center justify-center hover:bg-white hover:bg-opacity-20 transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-1"
          [class.text-white]="getTextColorForContrast(dataset.color) === 'white'"
          [class.text-gray-900]="getTextColorForContrast(dataset.color) === 'dark'"
          (click)="toggleDatasetVisibility(dataset); $event.stopPropagation()"
      [attr.aria-label]="
        (dataset.visible ? 'Hide' : 'Show') + ' ' + dataset.label
      "
          >
          <mat-icon class="text-sm w-4 h-4 self-baseline">
            {{ dataset.visible ? "visibility" : "visibility_off" }}
          </mat-icon>
        </button>
      </div>
    }
  </div>
}
